/**
 * External dependencies
 */
import inherits from 'inherits';

export default class Addon {
    
    constructor(cscom) {
        if (!(this instanceof Addon)) {
            return new Addon(cscom);
        }
        this.cscom = cscom;
    }

    list(data) {
        return this.cscom.req.get('/customer-site-api/addons/list', null, data);
    }

}
